
"use client";

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import styles from './feedback.module.css';

export default function FeedbackPage() {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/v1/auth/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          email: email || undefined,
          message,
        }),
      });

      const data = await response.json();

      if (response.ok && data.ok) {
        setSuccess(true);
        setMessage('');
        setEmail('');
        setTimeout(() => {
          router.push('/');
        }, 3000);
      } else {
        setError(data.detail || 'Ошибка отправки сообщения');
      }
    } catch (err) {
      setError('Ошибка соединения с сервером');
      console.error('Error submitting feedback:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className="pt-[calc(4rem+env(safe-area-inset-top))] md:pt-20"></div>
      <div className={styles.feedbackBox}>
        <div className={styles.header}>
          <button onClick={() => router.back()} className={styles.backButton}>
            ← Назад
          </button>
          <h1 className={styles.logo}>🎬 КиноФолио</h1>
        </div>

        <h2 className={styles.title}>Обратная связь</h2>
        <p className={styles.subtitle}>
          Расскажите о своём опыте работы с КиноФолио — что понравилось, что можно улучшить.
          Мы внимательно читаем каждое сообщение.
        </p>

        {success ? (
          <div className={styles.successBox}>
            <div className={styles.successIcon}>✓</div>
            <h3>Спасибо за ваш отзыв!</h3>
            <p>Мы получили ваше сообщение и учтём его при развитии сервиса.</p>
            <p className={styles.redirectText}>Возвращаемся на главную страницу...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.inputGroup}>
              <label htmlFor="email">
                Email <span className={styles.optional}>(необязательно, если авторизованы)</span>
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ваш@email.ru"
                disabled={loading}
                className={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="message">
                Ваше сообщение <span className={styles.required}>*</span>
              </label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Опишите ваш опыт работы с сервисом, предложения по улучшению или вопросы..."
                required
                disabled={loading}
                rows={8}
                maxLength={2000}
                className={styles.textarea}
              />
              <div className={styles.charCount}>
                {message.length} / 2000 символов
              </div>
            </div>

            {error && <div className={styles.error}>{error}</div>}

            <button
              type="submit"
              disabled={loading || !message.trim()}
              className={styles.button}
            >
              {loading ? 'Отправляем...' : 'Отправить сообщение'}
            </button>
          </form>
        )}

        <div className={styles.footer}>
          <p>Или напишите напрямую: <a href="mailto:support@kinofolio.com">support@kinofolio.com</a></p>
        </div>
      </div>
    </div>
  );
}
